import React from "react";
import usePreventBackgroundScroll from "../../../hooks/usePreventBackgroundScroll";
import Portal from "../Portal";

interface ModalProps {
  className: string;
  center?: boolean;
}

const Modal: React.FC<ModalProps> = ({
  children,
  className,
  center = true,
}) => {
  usePreventBackgroundScroll();
  return (
    <Portal>
      <section
        className={`fixed w-screen h-full overflow-auto max-h-screen z-50 left-0 top-0 bg-blur flex flex-col items-center ${
          center ? "justify-center" : ""
        } text-text`}
      >
        <section className={className}>{children}</section>
      </section>
    </Portal>
  );
};

export default Modal;
